import {lazy} from 'react';
import GenericFallbackSuspense from '../../../../../../v2/components/ui/GenericFallback/GenericFallbackSuspense';

const ZippayOverlayBody = lazy(() => import('./ZippayOverlayBody'/* webpackChunkName: 'ZippayOverlayBody' */));

export default function ZipPayOverlayLazyLoader() {
  return (
    <GenericFallbackSuspense>
      <ZippayOverlayBody />
    </GenericFallbackSuspense>
  );
}
